if (!customElements.get('accessories-catalog')) {
  customElements.define('accessories-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.onSubmit) return;
      this.onSubmit = async (event) => {
        const form = event.target.closest('.accessory-card__form');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled) return;
        const feedback = form.querySelector('[role="status"]');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        feedback.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          feedback.textContent = this.dataset.added;
          document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
          if (this.dataset.cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          feedback.textContent = error instanceof TypeError ? this.dataset.error : error.message;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      };
      this.addEventListener('submit', this.onSubmit);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.onSubmit);
      this.onSubmit = null;
    }
  });
}
